import { XVII18nService } from '@app/i18n/services';
import { ValueFormatterParams } from 'ag-grid-community';
import { get, isEmpty, startCase } from 'lodash';
import { DATA_SOURCE_ENUM_OPTIONS, DEFAULT_DATA_SOURCE } from '../types';

export const dataSourceFormatter = (
  params: ValueFormatterParams,
  options: { i18nService: XVII18nService },
): string => {
  return dataSourceValueFormatter(params.value, options);
};

export const dataSourceValueFormatter = (
  value: string,
  options: { i18nService: XVII18nService },
): string => {
  return options.i18nService.instant(
    isEmpty(value)
      ? DEFAULT_DATA_SOURCE
      : get(DATA_SOURCE_ENUM_OPTIONS, startCase(value), startCase(value)),
  );
};
